export const suggestions = [
  "All",
  "Music",
  "Computer Programming",
  "Comedy",
  "Namaste JavaScript",
  "News",
  "Podcasts",
  "Coding",
  "Stand up comedy",
  "Modi",
  "Cricket",
  "Movies",
  "ReactJS tutorials",
  "Dance videos",
  "Live",
  "Cooking",
  "Interview Preparations",
];
